export default __webpack_public_path__ + "static/media/Dogs.7528a500.png";